export default __webpack_public_path__ + "static/media/DragFileOntoAnother.a968586c.png";